import { appStore } from "src/mobx/AppStore";
import { LoginResponse } from "src/models/LoginResponse";

export class Application {
   
            
    public static saveAuthKey(key: string) {
        sessionStorage.setItem('auth_key', key)
    }

    public static isLoggedIn(){
        //This needs to implement a more stringent check, wherein the key is sent to server for validation
        const key = sessionStorage.getItem('auth_key');
        if(key === null){
            return false;
        }else{
            return true;
        }
    }

    public static login(loginResponse: LoginResponse) {
        Application.saveAuthKey(loginResponse.key);
        Application.saveUserName(loginResponse.username);
        appStore.setIsLoggedIn(true);
    }

    public static logout() {
        Application.removeAuthKey();
        appStore.setIsLoggedIn(false);
    }

    public static getAuthKey(){
        const key = sessionStorage.getItem('auth_key');
        return key;
    }

    public static removeAuthKey(){
        sessionStorage.removeItem('auth_key');
    }

    public static saveUserName(username: string) {
        sessionStorage.setItem('user_name', username)
    }

    public static getUserName() {
        const username = sessionStorage.getItem('user_name');
        return username;
    }

    public static setIsAgreed(isAgreed: boolean) {
        sessionStorage.setItem('is_agreed', isAgreed.toString())
    }

    public static getIsAgreed() {
        const key = sessionStorage.getItem('is_agreed');
        console.log(key)
        if(key === null){
            return false;
        }else if(key.toLowerCase() === "true") {
            return true;
        }else{
            return false;
        }
    } 

}


// WEBPACK FOOTER //
// ./src/core/application.ts